import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-651b52d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "user__photo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "user__info" }
const _hoisted_6 = { class: "bold" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = {
  key: 0,
  class: "justify-end"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-add" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "justify-end"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-wrapper info-black" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-add" })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "justify-end"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "user",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select')))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.photoUrl,
            alt: "user photo"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.fullName), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.contact.speciality), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (!_ctx.groupMember && !_ctx.invitedToGroup)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "btn-wrapper primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.inviteUserToGroup && _ctx.inviteUserToGroup(...args)))
              }, _hoisted_11)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.groupMember && _ctx.invitedToGroup)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          : _createCommentVNode("", true),
        (_ctx.groupMember)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", {
                class: "btn-wrapper info-black",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeUserFromGroup && _ctx.removeUserFromGroup(...args)))
              }, _hoisted_17)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}